export default __webpack_public_path__ + "img/component-info-2.a9661a3f.jpg";